import { render, staticRenderFns } from "./ModalAddPriceListToClient.vue?vue&type=template&id=6c7ffa2f&"
import script from "./ModalAddPriceListToClient.vue?vue&type=script&lang=js&"
export * from "./ModalAddPriceListToClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports